import type { SVGProps } from "react";

export const Customerio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="1em"
    viewBox="0 0 104.5 104.5"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Customer.io</title>
    <polygon
      points="78.3999 0 52.2 0 52.2 26.1001 78.3999 52.1997 52.2 78.3999 52.2 104.5 78.3999 104.5 104.5 78.3999 104.5 26.1001 78.3999 0"
      style={{ fill: "#0b353b", strokeWidth: 0 }}
    />
    <polygon
      points="39.2 13 26.1001 0 0 0 0 26.1001 13 39.1997 26.1001 52.1997 52.2 26.1001 39.2 13"
      style={{ fill: "#0b353b", strokeWidth: 0 }}
    />
    <polygon
      points="13 65.2998 0 78.3999 0 104.5 26.1001 104.5 39.2 91.3999 52.2 78.3999 26.1001 52.1997 13 65.2998"
      style={{ fill: "#0b353b", strokeWidth: 0 }}
    />
  </svg>
);

export default Customerio;
